import { Wall } from './wall.type';
import * as _ from 'lodash';
import { WallMonitor } from './monitor.type';
import { WallSharedConstants } from '../../wall-shared.constants';

export class Preset {
  public Id: string;
  public Title: string = WallSharedConstants.DEFAULT_PRESET_NAME;
  public MachinePhysicalAddress: string;
  public Quality: number = WallSharedConstants.DEFAULT_PRESET_QUALITY;
  public ExtendedGroup: Wall = new Wall([], 0);
  public MirrorGroups: Wall[] = [new Wall([], 0)];
  public Walls: Wall[] = [new Wall([], 0)];
  public isActive: boolean;
  public isUpdated: boolean;

  constructor(values: any = {}) {
    Object.assign(this, values);
  }

  static Restore(preset: Preset) {
    const restored = new Preset({
      Id: preset.Id,
      Title: preset.Title,
      Quality: preset.Quality,
      ExtendedGroup: this.initWall(preset.ExtendedGroup),
      MirrorGroups: preset.Walls && preset.Walls.length ? this.initWalls(preset.MirrorGroups) : [new Wall([], 0)],
      Walls: preset.Walls && preset.Walls.length ? this.initWalls(preset.Walls) : [new Wall([], 0)]
    });

    restored.ExtendedGroup.Monitors.filter(x => !!x).forEach(
      (monitor: WallMonitor, i: number) => (monitor.DisplayText = monitor.DisplayText || `${i + 1}`)
    );
    restored.MirrorGroups.filter(x => !!x).forEach(this.updateMonitorName.bind(null, 'M'));
    restored.Walls.filter(x => !!x).forEach(this.updateMonitorName.bind(null, 'W'));

    return restored;
  }

  static Duplicate(preset: Preset): Preset {
    const clone = _.cloneDeep(preset);
    clone.Title = '';
    return clone;
  }

  static updateMonitorName(wallPrefix: 'M' | 'W', wall: Wall, idx: number) {
    const maxIndexInColumn = Preset.getMaxColumnIndex(wall.Monitors);

    // TODO: Always set IsCalibrated value
    wall.IsCalibrated = false;
    wall.Monitors.filter(x => !!x).forEach((monitor, index) => {
      let monitorIdx = Preset.getMonitorIndex(monitor, maxIndexInColumn);

      if (wallPrefix === 'M') {
        monitorIdx = index + 1;
      } else if (!wall.IsAligned) {
        monitorIdx += index;
      }

      monitor.DisplayText = `${wallPrefix}-${String.fromCharCode(
        65 + idx
      )}${monitorIdx}`;
    });
  }

  static getMonitorIndex(monitor: WallMonitor, maxColumn: number): number {
    let index: number;

    if (monitor.Row === 0) {
      index = monitor.Column + 1;
    } else if (monitor.Row === 1) {
      index = maxColumn + monitor.Column + 1;
    } else {
      index = maxColumn * monitor.Row + monitor.Column + 1;
    }

    return index;
  }

  static getMaxColumnIndex(monitors: WallMonitor[]): number {
    if (monitors.length <= 1) {
      return monitors[0] ? monitors[0].Column + 1 : 0;
    } else {
      return monitors.sort((a, b) => b.Column - a.Column)[0].Column + 1;
    }
  }

  static initWalls(wallsToCheck: Wall[]): Wall[] {
    wallsToCheck.forEach((wall: Wall) => {
      this.initWall(wall);
    });

    return _.cloneDeep(wallsToCheck);
  }

  static initWall(wallToCheck: Wall): Wall {
    wallToCheck.Monitors = wallToCheck.Monitors.filter((monitor: WallMonitor) => !!monitor);
    return _.cloneDeep(wallToCheck);
  }
}
